import { FC, useState } from 'react';
import { DebouncedInput } from '@/components/functional/DebouncedInput/DebouncedInput.tsx';
import SelectInput from '@/components/functional/SelectInput/SelectInput.tsx';
import TextInput from '@/components/functional/TextInput/TextInput.tsx';
import DatePickerInput from '@/components/functional/DatePickerInput/DatePickerInput.tsx';
import { Button } from 'react-daisyui';
import CheckboxInput from '@/components/functional/CheckboxInput/CheckboxInput.tsx';
import OtpInput from '@/components/functional/OtpInput/OtpInput.tsx';
import TextArea from '@/components/functional/TextArea/TextArea.tsx';
import { Oklch } from 'culori';
import ColorPicker from '@/components/functional/ColorPicker/ColorPicker.tsx';
import FileInput from '@/components/functional/FileInput/FileInput.tsx';

const InputsPage: FC = () => {
  const [value, setValue] = useState('');
  const [file, setFile] = useState<File>();
  const [debouncedValue, setDebouncedValue] = useState('');
  const [selectValue, setSelectValue] = useState('');
  const [dateValue, setDateValue] = useState('');
  const [otpValue, setOtpValue] = useState('');
  const [currentColor, setCurrentColor] = useState<Oklch | undefined>();

  const [error, setError] = useState('');
  const [showLabel, setShowLabel] = useState(true);

  return (
    <div className="flex flex-col gap-4 w-[400px]">
      <Button color="primary" onClick={() => setError((prev) => (prev ? '' : 'Error'))}>
        Toggle error
      </Button>
      <Button color="primary" onClick={() => setShowLabel((prev) => !prev)}>
        Toggle labels
      </Button>
      <TextInput
        label={showLabel ? 'Text input' : undefined}
        error={error}
        placeholder="placeholder"
        value={value}
        onChange={(e) => setValue(`${e.target.value}`)}
      />
      <DebouncedInput
        label={showLabel ? 'Debounced text input' : undefined}
        error={error}
        placeholder="placeholder"
        value={debouncedValue}
        onChange={(val) => setDebouncedValue(`${val}`)}
      />
      <TextArea
        label={showLabel ? 'Textarea input' : undefined}
        error={error}
        placeholder="placeholder"
        value={value}
        onChange={(e) => setValue(`${e.target.value}`)}
      />
      <SelectInput
        label={showLabel ? 'Select' : undefined}
        error={error}
        placeholder="placeholder"
        value={selectValue}
        onChange={(val) => setSelectValue(val)}
        options={[
          {
            value: 'Single',
            label: 'Single',
          },
          {
            value: 'Complicated',
            label: 'Complicated',
          },
          {
            value: 'In Relationship',
            label: 'In Relationship',
          },
        ]}
      />
      <FileInput
        label={showLabel ? 'File input' : undefined}
        error={error}
        placeholder="placeholder"
        value={file}
        accept="image/*"
        onChange={(files) => setFile(files[0])}
      />
      <CheckboxInput label={showLabel ? 'Checkbox input' : undefined} error={error} />
      <DatePickerInput
        label={showLabel ? 'Date picker' : undefined}
        error={error}
        value={dateValue}
        onChange={(val) => setDateValue(val ?? '')}
        placeholder="placeholder"
      />
      <OtpInput
        label={showLabel ? 'Otp Input' : undefined}
        error={error}
        numInputs={5}
        value={otpValue}
        onChange={(val) => setOtpValue(val)}
      />
      <ColorPicker className="max-w-[400px]" onChange={setCurrentColor} currentColor={currentColor} />
    </div>
  );
};

export default InputsPage;
